import React from 'react';
import { ScrollTextIcon } from 'lucide-react';
export function TermsAndConditions() {
  return <main className="w-full min-h-full bg-slate-50 text-slate-900" data-id="element-162">
      <div className="max-w-3xl mx-auto px-6 py-16 sm:py-20" data-id="element-163">
        <header className="mb-10" data-id="element-164">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-medium mb-4" data-id="element-165">
            <ScrollTextIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-166" />
            Legal
          </div>
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900" data-id="element-167">
            Términos y Condiciones
          </h1>
          <p className="mt-4 text-sm text-slate-500" data-id="element-168">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-MX', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </header>

        <article className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed" data-id="element-169">
          <section data-id="element-170">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-171">
              1. Aceptación de los términos
            </h2>
            <p data-id="element-172">
              Al acceder, navegar o utilizar los servicios, formularios,
              páginas, contenidos o recursos de <strong data-id="element-173">Real en línea</strong>,
              aceptas quedar sujeto a estos Términos y Condiciones. Si no estás
              de acuerdo con alguno de estos términos, debes abstenerte de
              utilizar este sitio y sus servicios.
            </p>
          </section>

          <section data-id="element-174">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-175">
              2. Objeto del sitio
            </h2>
            <p data-id="element-176">
              Real en línea pone a disposición información, contenidos,
              formularios, páginas de contacto, materiales promocionales y otros
              recursos relacionados con sus servicios, productos, actividades
              comerciales o informativas. El uso del sitio tiene fines
              informativos, comerciales y de contacto con usuarios o clientes
              potenciales.
            </p>
          </section>

          <section data-id="element-177">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-178">
              3. Uso adecuado
            </h2>
            <p data-id="element-179">
              El usuario se compromete a utilizar este sitio de manera lícita,
              responsable y de buena fe. Queda prohibido usar el sitio para
              realizar actividades fraudulentas, engañosas, ilícitas, abusivas o
              que puedan afectar el funcionamiento del sitio, los derechos de
              terceros o la reputación de Real en línea.
            </p>
          </section>

          <section data-id="element-180">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-181">
              4. Información proporcionada por el usuario
            </h2>
            <p data-id="element-182">
              Cuando el usuario complete formularios, solicite información,
              envíe mensajes o proporcione datos personales, declara que la
              información suministrada es verdadera, exacta y actualizada. El
              usuario es responsable de cualquier información falsa, incompleta
              o desactualizada que proporcione.
            </p>
          </section>

          <section data-id="element-183">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-184">
              5. Propiedad intelectual
            </h2>
            <p data-id="element-185">
              Todos los contenidos del sitio, incluyendo textos, diseños,
              logotipos, marcas, gráficos, imágenes, estructura, software,
              código y demás materiales, son propiedad de Real en línea o se
              utilizan con autorización, y están protegidos por la normativa
              aplicable en materia de propiedad intelectual. Queda prohibida su
              reproducción, distribución, modificación, publicación o uso no
              autorizado.
            </p>
          </section>

          <section data-id="element-186">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-187">
              6. Enlaces a terceros
            </h2>
            <p data-id="element-188">
              El sitio puede contener enlaces a sitios web, plataformas o
              servicios de terceros. Real en línea no controla ni asume
              responsabilidad por el contenido, políticas, disponibilidad o
              prácticas de privacidad de dichos terceros. El acceso a enlaces
              externos será bajo responsabilidad exclusiva del usuario.
            </p>
          </section>

          <section data-id="element-189">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-190">
              7. Privacidad y datos personales
            </h2>
            <p data-id="element-191">
              El tratamiento de los datos personales proporcionados por los
              usuarios se rige por la Política de Privacidad publicada por Real
              en línea. Al utilizar este sitio, el usuario reconoce haber leído
              dicha política y acepta el tratamiento de sus datos conforme a lo
              ahí establecido.
            </p>
          </section>

          <section data-id="element-192">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-193">
              8. Limitación de responsabilidad
            </h2>
            <p data-id="element-194">
              Real en línea realiza esfuerzos razonables para mantener la
              información del sitio actualizada y disponible, pero no garantiza
              que el contenido esté libre de errores, interrupciones, omisiones
              o desactualizaciones. En la máxima medida permitida por la ley,
              Real en línea no será responsable por daños directos, indirectos,
              incidentales, consecuenciales o pérdidas derivadas del uso o
              imposibilidad de uso del sitio.
            </p>
          </section>

          <section data-id="element-195">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-196">
              9. Modificaciones
            </h2>
            <p data-id="element-197">
              Real en línea podrá modificar, actualizar o sustituir en cualquier
              momento estos Términos y Condiciones, así como cualquier contenido
              o funcionalidad del sitio, sin previo aviso. Las modificaciones
              entrarán en vigor desde su publicación en esta página.
            </p>
          </section>

          <section data-id="element-198">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-199">
              10. Legislación aplicable
            </h2>
            <p data-id="element-200">
              Estos Términos y Condiciones se interpretarán conforme a la
              legislación aplicable del lugar donde opere Real en línea, salvo
              que una norma imperativa disponga otra cosa. En caso de
              controversia, las partes se someterán a la jurisdicción competente
              conforme a la normativa aplicable.
            </p>
          </section>

          <section data-id="element-201">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-202">
              11. Contacto
            </h2>
            <p data-id="element-203">
              Si tienes preguntas sobre estos Términos y Condiciones, puedes
              contactarnos en{' '}
              <a href="mailto:realenlinea1@gmail.com" className="font-medium text-emerald-700 underline underline-offset-2 hover:text-emerald-800" data-id="element-204">
                realenlinea1@gmail.com
              </a>
              .
            </p>
          </section>
        </article>

        <footer className="mt-12 pt-6 border-t border-slate-200 text-xs text-slate-500" data-id="element-205">
          © {new Date().getFullYear()} Real en línea. Todos los derechos
          reservados.
        </footer>
      </div>
    </main>;
}